import {createSvgIcon} from '../create-svg-icon';

export const SignalCellular0BarIcon = createSvgIcon(
  <path d="M2 22h20V2L2 22zm18-2H6.83L20 6.83V20z" />
, 'SignalCellular0BarOutlined');
